import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import Alert from '@components/common/alert';
import { useToast } from '@components/common/toast';
import { useEventsProfileDownload } from '@repository/event/useEvent';
import { useMatchProfile } from '@repository/match';
import { useMarketingInfo } from '@repository/users/useUsers';
import { useUserInfo } from '@repository/auth/useUserInfo';
import EventMailProfileModals from './modal';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import FileUtil from '@utils/fileUtil';
import useModals from '@utils/hooks/useModals';
import classnames from 'classnames/bind';
import styles from './floatingBar.module.scss';
const cx = classnames.bind(styles);

const FloatingBar = () => {
  const { openModal, closeModal, isVisible } = useModals(['MARKETING_POLICY_AGREE', 'MARKETING_POLICY_COMPLETE']);
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { data: matchProfileInfo } = useMatchProfile(isLogin);
  const { data: marketingInfo } = useMarketingInfo();
  const isCompleteProfile = matchProfileInfo?.profile.profileRequiredCompleteYn;
  const isMarketingAgree = marketingInfo?.emailYn && marketingInfo?.smsYn;

  const Toast = useToast();
  //합격자 이력서 다운로드
  const { mutateAsync: downloadResume } = useEventsProfileDownload(
    (data) => {
      FileUtil.fileOpenToPdf(data);

      Alert({
        title: '혜택 다운로드 완료!',
        desc: (
          <>
            다운로드 받은 [합격자 프로필 이력서 모음.ZIP]을
            <br />
            토대로 내 프로필 보완해보세요.
          </>
        ),
        dimmed: true,
        onClickBgClose: true,
      });
      return;
    },
    (e) => Toast({ type: 'error', iconType: 'info', content: e.response?.data.message }),
  );

  const handleDownloadResume = () => {
    if (!isMarketingAgree) {
      openModal('MARKETING_POLICY_AGREE');
      return;
    }

    downloadResume();
  };

  return (
    <>
      {/*하단 플로팅 바 */}
      <div className={cx('floatingBar')}>
        <div className={cx('floatingInner')}>
          <Link className={cx('floatingBtn')} href={RouteUrl.PROFILE} target="_blank">
            프로필 작성하기
            <Icon name="guideLight" width={32} height={32} fill={Colors.C_JOBDA_BLACK} />
          </Link>
          <button
            className={cx('floatingBtn', 'btnDownload')}
            disabled={!isCompleteProfile}
            onClick={handleDownloadResume}
          >
            합격자 프로필 다운로드
            <div className={cx('btnIcon')}>
              <Icon name="download" width={32} height={32} fill={Colors.C_JOBDA_BLACK} />
            </div>
          </button>
        </div>
      </div>

      <EventMailProfileModals closeModal={closeModal} isVisible={isVisible} openModal={openModal} />
    </>
  );
};

export default FloatingBar;
